import { usePostHog } from 'posthog-js/react';
import styled from 'styled-components';

import { useMobile } from '@/hooks/useMobile/useMobile';
import useHostHomeBanner from '@/hooks/usePartners/useHostHomeBanner/useHostHomeBanner';

const BANNER_LOCATION = 'HOSTS_PANEL';

const BannerLink = styled.a`
  display: block;
  margin-top: 32px;
`;

const BannerImage = styled.img`
  border-radius: 8px;
  width: 700px;
  height: 161px;
  object-fit: cover;

  @media (max-width: 1000px) {
    width: 300px;
    height: 96px;
  }
`;

const HostHomeBanner = () => {
  const posthog = usePostHog();
  const { isMobile } = useMobile();
  const { banner } = useHostHomeBanner();

  if (!banner) return null;

  const handleClick = () => {
    if (posthog) {
      posthog.capture('FRANQUIA - Clicou no banner da home', {
        banner_id: banner.id,
        banner_name: banner.name,
        destination_url: banner.redirect_link,
        device: isMobile ? 'mobile' : 'desktop',
        location: BANNER_LOCATION,
      });
    }
  };

  const imageSrc = isMobile ? banner.mobile_image_url : banner.desktop_image_url;

  return (
    <BannerLink
      href={banner.redirect_link}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      <BannerImage src={imageSrc} alt={banner.name} />
    </BannerLink>
  );
};

export default HostHomeBanner;
